import React from 'react';
import styles from './StickyButtonBar.module.scss';
import { getClassName } from '@onsolve/utils.get-class-name';
const StickyButtonBar = ({ className, leftContent = <></>, rightContent }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'sticky-button-bar',
        className,
        modifiers: {
            blue: true,
        },
        styles,
    });
    return (<div className={rootClass}>
            <div className={getChildClass('left')}>{leftContent}</div>
            <div className={getChildClass('right')}>{rightContent}</div>
        </div>);
};
export default StickyButtonBar;
